import type { FunctionComponent, ReactNode } from 'react';

export const FieldLabel: FunctionComponent<{ readonly children: ReactNode; readonly className?: string }> = ({
    children,
    className = '',
}) => <div className={`flex flex-col gap-xs text-text-content-subtle text-xxs ${className}`.trim()}>{children}</div>;
